var _rect, _rect2, _line, _line2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 474,
    height: 474,
    rx: 27,
    stroke: "#B1B1B1",
    strokeWidth: 12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 114.004,
    y1: 488.004,
    x2: 360.784,
    y2: 241.223,
    stroke: "#B1B1B1",
    strokeWidth: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 359.121,
    y1: 243.879,
    x2: 487.815,
    y2: 372.572,
    stroke: "#B1B1B1",
    strokeWidth: 12,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 205,
    r: 37,
    fill: "white",
    stroke: "#B1B1B1",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.c5f8cfa6fbf8473312a9e5484fac8def.svg";
export { ForwardRef as ReactComponent };